<div mdbModal #verResultado="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1"
    role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Resultado
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="verResultado.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <h5>Las siguientes Notas de Venta fueron convertidas en Facturas:</h5>
                <div class="table-responsive">
                    <table class="table table-striped table-hover table-sm align-middle">
                        <thead class="grey lighten-2">
                            <tr>
                                <th scope="col" class="text-center">Convertida</th>
                                <th scope="col" class="text-center">Nro. factura</th>
                                <th scope="col" class="text-center">Nota de venta</th>
                                <th scope="col" class="text-center">Cliente</th>
                                <th scope="col" class="text-center">Vendedor</th>
                                <th scope="col" class="text-center">Monto total</th>
                                <th scope="col" class="text-center"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="detalleDocumentoAll?.length === 0">
                                <td colspan="100%" style="text-align: center">
                                    No se encontró información
                                </td>
                            </tr>
                            <tr *ngFor="let doc of detalleDocumento">
                                <td class="text-center">
                                    <mdb-icon *ngIf="doc.estadoFactura" fas icon="circle" class="text-success">
                                    </mdb-icon>
                                    <mdb-icon *ngIf="!doc.estadoFactura" fas icon="circle" class="text-danger">
                                    </mdb-icon>
                                </td>
                                <td class="text-center">{{doc.cabecera.folio | numerico}}</td>
                                <td class="text-center">{{doc.cabecera.nota_venta | numerico}}</td>
                                <td class="text-center">{{doc.cabecera.cliente_nombre}}</td>
                                <td class="text-center">{{doc.cabecera.vendedor_nombre}}</td>
                                <td class="text-center">$ {{doc.cabecera.monto_total | numerico}}</td>
                                <td class="text-center">
                                    <ng-container *ngIf="!doc.estadoFactura">
                                        <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect
                                            class="btn-actions-sm" mdbTooltip="Ver" placement="right"
                                            (click)="showErrores(doc.logErrores)">
                                            <mdb-icon fas icon="eye"></mdb-icon>
                                        </button>
                                    </ng-container>
                                </td>
                            </tr>

                        </tbody>
                        <app-pagination [context]="paginationContextDocumento"
                            (onPageChange)="onPageChangeDocumentos($event)" *ngIf="detalleDocumentoAll?.length > 0">
                        </app-pagination>
                    </table>
                    <table class="table table-striped table-hover table-sm align-middle">
                        <tbody style="text-align:right;">
                            <tr>
                                <td class="col-8" style="font-weight: bold; font-size: 15px;">
                                    <span style="color: red;">Total Neto </span>
                                    <span>$ {{sumMontoNeto | numerico}}</span>
                                </td>
                                <td class="col-4" style="font-weight: bold; font-size: 15px;">
                                    <span style="color: red;">Total Bruto </span>
                                    <span>$ {{sumMontoBruto | numerico}}</span>
                                </td>
                        </tbody>
                    </table>
                </div>

                <!-- <h5>¿ Está seguro ?</h5> -->
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="closeModal()"
                    mdbWavesEffect>
                    Cerrar
                </button>
                <!-- <button type="button" class="btn btn-success waves-light" data-dismiss="modal"
                    (click)="accept()" mdbWavesEffect>
                    Si, Estoy seguro
                </button> -->
            </div>
        </div>
    </div>
</div>


<div mdbModal #erroresModal="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1"
    role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Errores
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="erroresModal.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="table-responsive">
                    <table class="table table-striped table-hover table-sm align-middle">
                        <thead class="grey lighten-2">
                            <tr>
                                <th scope="col" class="text-center">Tipo</th>
                                <th scope="col" class="text-center">Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="detalleErroresAll?.length === 0">
                                <td colspan="100%" style="text-align: center">
                                    Sin errores
                                </td>
                            </tr>
                            <tr *ngFor="let detalle of detalleErrores">
                                <td>{{detalle.tipo}}</td>
                                <td>{{detalle.texto}}</td>
                            </tr>

                        </tbody>
                        <app-pagination [context]="paginationContextErrores"
                            (onPageChange)="onPageChangeErrores($event)" *ngIf="detalleErroresAll?.length > 0">
                        </app-pagination>
                    </table>
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="erroresModal.hide()"
                    mdbWavesEffect>
                    Cerrar
                </button>
            </div>
        </div>
    </div>
</div>
